import { cn } from '@/lib/utils'
import { toneClass, type DsTone } from '@/ds/tone'
import type { DsIcon } from '@/ds/icons'

export interface DsIconGlyphProps {
  icon: DsIcon
  size?: number
  tone?: DsTone
  muted?: boolean
  className?: string
  /** Give a label only when the icon carries meaning on its own; decorative icons are hidden. */
  semanticLabel?: string
}

export function DsIconGlyph({ icon: Icon, size = 20, tone, muted, className, semanticLabel }: DsIconGlyphProps) {
  return (
    <Icon
      size={size}
      strokeWidth={1.5}
      aria-hidden={semanticLabel ? undefined : true}
      aria-label={semanticLabel}
      role={semanticLabel ? 'img' : undefined}
      className={cn('shrink-0', tone ? toneClass[tone].text : muted ? 'text-muted-foreground' : undefined, className)}
    />
  )
}
